"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeparatorBuilder = void 0;
const react_1 = __importDefault(require("react"));
const SeparatorBuilder = ({ elements, separator, children, getKey }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, elements.map((el, index) => (react_1.default.createElement(react_1.default.Fragment, { key: getKey(el, index) },
        children(el, index),
        index < elements.length - 1 && separator)))));
};
exports.SeparatorBuilder = SeparatorBuilder;
